import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

interface DayGroupHeaderProps {
  label: string;
  count: number;
}

const DayGroupHeader = ({ label, count }: DayGroupHeaderProps) => (
  <Box display="flex" alignItems="center" gap={1.5} sx={{ marginBottom: 2, marginTop: 3 }}>
    <Box sx={{ width: 4, height: 22, borderRadius: 999, bgcolor: 'primary.main' }} />
    <Typography variant="h6" sx={{ fontWeight: 600 }}>{label}</Typography>
    <Chip label={count} size="small" sx={{ bgcolor: 'action.hover', fontWeight: 600 }} />
    <Box sx={{ flexGrow: 1, height: '1px', bgcolor: 'divider' }} />
  </Box>
);

export default DayGroupHeader;
